import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { Thread } from '../../data-contract/chat';
import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { chatKeys } from './query-keys';

export const useCreateChatThread = (): UseMutationResult<Thread, Error, void> => {
    const queryClient = useQueryClient();
    const { createChatThread } = useApplicationFetchers();

    return useMutation({
        mutationFn: async () => {
            const result = await createChatThread();

            if (result.isErr === true) {
                throw result.error;
            }

            return result.value;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: chatKeys.threads() });
        },
    });
};
